import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface SearchInputProps {
    onSearchChange: (value: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ onSearchChange }) => {
    return (
        <Box width="100%">
            <TextField
                fullWidth
                variant="filled"
                placeholder="Rechercher par mot clés"
                onChange={(e) => onSearchChange(e.target.value)}
                sx={{
                    backgroundColor: "#f0f2f2",
                    borderRadius: "8px",
                    "& .MuiFilledInput-root": {
                        borderRadius: "8px",
                        backgroundColor: "#f0f2f2",
                        boxShadow: "none",
                        display: "flex",
                        alignItems: "center",
                        "&::before, &::after": { display: "none" },
                    },
                    "& input": {
                        padding: "10px 12px",
                    },
                }}
                inputProps={{ sx: { padding: '0px', '::placeholder': { color: '#4e4f4f', opacity: 1 } } }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ marginBottom: '10px' }}>
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    disableUnderline: true,
                }}
            />
        </Box>
    );
};

export default SearchInput;
